export class LeftBannerModel {
    public title: string;
    public subtitle: string;
    constructor() {
        this.title =  'Welcome to Work Order!' ;
        this.subtitle = 'The ultimate framework for next generation work order management';
    }
}
